// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__vaAjm","borderTop":"styles_borderTop__1253E"};